"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Container;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
function Container(props) {
  return _react["default"].Children.toArray(props.children).map(function (child) {
    if (! /*#__PURE__*/_react["default"].isValidElement(child)) return null;
    return /*#__PURE__*/_react["default"].cloneElement(child, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, props), child.props));
  });
}
Container.displayName = 'Container';
module.exports = exports.default;